// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetTopicSettingsByIdParam,
    BaseResponseTopicSettingFoundResponse,
    PutTopicSettingsByIdParam,
    PutTopicSettingsByIdBody,
    BaseResponseVoid,
    DeleteTopicSettingsByIdParam,
} from '../../types';

/**
 * 话题配置详情
 *
 * @export
 * @tags 话题配置
 * @link [GET] /topicSettings/{id}
 * @param id
 */
export function getTopicSettingsById(
    options: ApiOptions<GetTopicSettingsByIdParam, never> & { segments: GetTopicSettingsByIdParam }
): Promise<BaseResponseTopicSettingFoundResponse> {
    return request<never, GetTopicSettingsByIdParam, never>('/topicSettings/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getTopicSettingsById',
    });
}

/**
 * 话题配置-更新
 *
 * @export
 * @tags 话题配置
 * @link [PUT] /topicSettings/{id}
 * @param id
 */
export function putTopicSettingsById(
    data: PutTopicSettingsByIdBody,
    options: ApiOptions<PutTopicSettingsByIdParam, never> & { segments: PutTopicSettingsByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutTopicSettingsByIdBody, PutTopicSettingsByIdParam, never>(
        '/topicSettings/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putTopicSettingsById' }
    );
}

/**
 * 话题配置-删除
 *
 * @export
 * @tags 话题配置
 * @link [DELETE] /topicSettings/{id}
 * @param id
 */
export function deleteTopicSettingsById(
    options: ApiOptions<DeleteTopicSettingsByIdParam, never> & {
        segments: DeleteTopicSettingsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteTopicSettingsByIdParam, never>('/topicSettings/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteTopicSettingsById',
    });
}

export const meta = [
    { tags: ['话题配置'], path: '/topicSettings/{id}', method: 'get' },
    { tags: ['话题配置'], path: '/topicSettings/{id}', method: 'put' },
    { tags: ['话题配置'], path: '/topicSettings/{id}', method: 'delete' },
];
